import mooneLogo from "Assets/Images/Images/moone-logo.svg";
import { Link } from "Navigation/Link";
import { Resources, useResource } from "Translations/Resources";
import SensorsIcon from "@mui/icons-material/Sensors";
import { Stack } from "@mui/material";
import { type ReactNode, useEffect } from "react";

type Props = {
  title: string;
  children: ReactNode;
};

export const NfcLayout = ({ title, children }: Props) => {
  const { t } = useResource();

  useEffect(() => {
    document.title = `${title} | ${t(Resources.Common.AppName)}`;
  }, [title, t]);

  return (
    <Stack justifyContent="center" px={[2, 4, 4, 0]}>
      <SensorsIcon
        sx={{
          position: "absolute",
          top: ["27%", "25%", "30%"],
          left: ["70%", "70%", "70%", "70%"],
          transform: "translate(-50%, -50%)",
          fontSize: [0, 0, 700, 900],
          opacity: 0.03,
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 1,
        }}
        aria-hidden="true"
      />
      <Stack sx={{ zIndex: 2 }} alignSelf="center" my={2} gap={2}>
        <Link to="/">
          <img src={mooneLogo} alt="Moone" width="143" />
        </Link>
        {children}
      </Stack>
    </Stack>
  );
};
